import { Component, createRef } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import api from "../../utils/axios";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
  isEmail,
  isNumberWithPoint,
  removeChar,
  getMaritalStatus,
  getStateList,
  validatedDate,
  showDrobdownValue,
  apiDate,
  normalizeValue,
  decodeValue,
  hasPermission,
} from "../Settings/Settings";
import { downloadUrl } from "../Settings/Config";

import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import noImage from "../../assets/images/faces/1.jpg";
const module = "candidate";
const modulePath = "/candidate";
const moduleName = "Candidate";
const today = new Date();
const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
const moduleID = 13;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        fname: "",
        lname: "",
        c_rank: "",
        avb_date: "",
        nationality: "",
        m_status: "",
        dob: "",
        birth_place: "",
        work_nautilus: "",
        c_vessel: "",
        indos_number: "",
        experience: "",
        mobile_code1: "",
        c_mobi1: "",
        mobile_code2: "",
        c_mobi2: "",
        email1: "",
        email2: "",
        zone: "",
        grade: "",
        boiler_suit_size: "",
        safety_shoe_size: "",
        height: "",
        weight: "",
        l_country: "",
        group: "",
        vendor: "",
        us_visa: "",
        c_ad1: "",
        c_country: "",
        c_state: "",
        c_city: "",
        c_pin: "",
        p_ad1: "",
        p_country: "",
        p_city: "",
        p_state: "",
        p_pin: "",
        photos: "",
        resume: "",
        active_details: "",
        nearestAirport:"",
        candidateId: "",
      },
      detaildata: [],
      error_msg: "",
      rankList: [],
      experienceList: [],
      countryList: [],
      companyList: [],
      vessleTypeList: [],
      gradeList: [],
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          const candidateId = (this.state.editID!=="")?decodeValue(this.state.editID):nextProps.formpost[0].candidateId
          this.props.history.push(`/candidate/view/${candidateId}`);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const active_details = result.active_details === 1 ? "Active" : "In Active";
          const status =
            result.active_details !== "" && result.active_details !== null
              ? {
                  label: active_details,
                  value: result.active_details,
                }
              : "";
          let groupLabel = "";
          if (result.group === "1") {
            groupLabel = "Officer";
          } else if (result.group === "2") {
            groupLabel = "Rating";
          } else if (result.group === "6") {
            groupLabel = "IV crew";
          }
          const us_visa = result?.us_visa ?? "";
          let us_visa_ = "";
          if (us_visa !== "") {
            if (us_visa === 1) {
              us_visa_ = "Yes";
            } else {
              us_visa_ = "No";
            }
          }

          const c_country = result.c_country;
          let c_state = "";
          if ((c_country ?? "").toString() === "108") {
            c_state = { label: result.c_state, value: result.c_state };
          } else {
            c_state = normalizeValue(result.c_state);
          }
          const p_country = result.p_country;
          let p_state = "";
          if ((p_country ?? "").toString() === "108") {
            p_state = { label: result.p_state, value: result.p_state };
          } else {
            p_state = normalizeValue(result.p_state);
          }
          const mobile_code1 = result.mobile_code1 || '91';
          const clientupdatedata = {
            candidateId: result.candidateId,
            fname: normalizeValue(result.fname),
            lname: normalizeValue(result.lname),
            c_rank: showDrobdownValue(result.c_rank, result.c_rank),
            avb_date: validatedDate(result.avb_date),
            nationality: showDrobdownValue(result.nationalityName, result.nationality),
            m_status: showDrobdownValue(result.m_status, result.m_status),
            dob: validatedDate(result.dob),
            birth_place: normalizeValue(result.birth_place),
            work_nautilus: showDrobdownValue(result.work_nautilus, result.work_nautilus),
            c_vessel: showDrobdownValue(result.c_vessel, result.c_vessel),
            indos_number: normalizeValue(result.indos_number),
            experience: showDrobdownValue(result.experience, result.experience),
            mobile_code1: normalizeValue(mobile_code1),
            c_mobi1: normalizeValue(result.c_mobi1),
            mobile_code2: normalizeValue(result.mobile_code2),
            c_mobi2: normalizeValue(result.c_mobi2),
            email1: normalizeValue(result.email1),
            email2: normalizeValue(result.email2),
            zone: showDrobdownValue(result.zone, result.zone),
            grade: showDrobdownValue(result.grade, result.grade),
            boiler_suit_size: normalizeValue(result.boiler_suit_size),
            safety_shoe_size: normalizeValue(result.safety_shoe_size),
            height: normalizeValue(result.height),
            weight: normalizeValue(result.weight),
            l_country: showDrobdownValue(result.l_countryName, result.l_country),
            group: showDrobdownValue(groupLabel, result.group),
            vendor: showDrobdownValue(result.vendorName, result.vendor),
            us_visa: showDrobdownValue(us_visa_, result.us_visa),
            c_ad1: normalizeValue(result.c_ad1),
            c_country: showDrobdownValue(result.c_countryName, result.c_country),
            c_city: normalizeValue(result.c_city),
            c_state: c_state,
            c_pin: normalizeValue(result.c_pin),
            p_ad1: normalizeValue(result.p_ad1),
            p_country: showDrobdownValue(result.p_countryName, result.p_country),
            p_city: normalizeValue(result.p_city),
            p_state: p_state,
            p_pin: normalizeValue(result.p_pin),
            photos: result.photos !== "" && result.photos !== null ? result.photos : "",
            resume: result.resume !== "" && result.resume !== null ? result.resume : "",
            active_details: status,
            nearestAirport:normalizeValue(result.nearestAirport)
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  loadDropdown() {
    api
      .get("rank/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ rankList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("experience/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ experienceList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("company/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ companyList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vesseltype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vessleTypeList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });

    api
      .get("others/countrylist")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ countryList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("grade/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ gradeList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }), () => {
      if (field === "c_country") {
        this.setState(update(this.state, { postdata: { c_state: { $set: "" } } }));
      } else if (field === "p_country") {
        this.setState(update(this.state, { postdata: { p_state: { $set: "" } } }));
      }
    });
  };

  handleSubmit = () => {
    const postData = this.state.postdata;
    const c_country = postData.c_country?.value || '';
    console.log(c_country, "p_countryp_countryp_country");
    let c_state = "";
    if ((c_country ?? "").toString() === "108") {
      c_state = postData.c_state?.value;
    } else {
      c_state = postData.c_state;
    }
    const p_country = postData.p_country?.value;
    let p_state = "";
    if ((p_country ?? "").toString() === "108") {
      p_state = postData.p_state?.value;
    } else {
      p_state = postData.p_state;
    }

    const postObject = {
      fname: postData.fname.toUpperCase(),
      lname: postData.lname.toUpperCase(),
      c_rank: postData.c_rank?.value ?? "",
      avb_date: apiDate(postData.avb_date),
      nationality: postData.nationality?.value ?? "",
      m_status: postData.m_status?.value ?? "",
      dob: apiDate(postData.dob),
      birth_place: postData.birth_place,
      work_nautilus: postData.work_nautilus?.value,
      c_vessel: postData.c_vessel?.value,
      indos_number: postData.indos_number.toUpperCase(),
      experience: postData.experience?.value ?? "",
      mobile_code1: postData.mobile_code1,
      c_mobi1: postData.c_mobi1,
      mobile_code2: postData.mobile_code2,
      c_mobi2: postData.c_mobi2,
      email1: postData.email1,
      email2: postData.email2,
      zone: postData.zone?.value ?? "",
      grade: postData.grade?.value ?? "",
      boiler_suit_size: postData.boiler_suit_size.toUpperCase(),
      safety_shoe_size: postData.safety_shoe_size.toUpperCase(),
      height: postData.height.toUpperCase(),
      weight: postData.weight.toUpperCase(),
      l_country: postData.l_country?.value || 0,
      group: postData.group?.value || "",
      vendor: postData.vendor?.value || "",
      us_visa: postData.us_visa?.value || 0,
      c_ad1: postData.c_ad1,
      c_country: (c_country!=="")?c_country:0,
      c_city: postData.c_city,
      c_state: c_state,
      c_pin: postData.c_pin,
      p_ad1: postData.p_ad1,
      p_country: p_country,
      p_city: postData.p_city,
      p_state: p_state,
      p_pin: postData.p_pin,
      active_details: postData.active_details?.value ?? 0,
      nearestAirport:postData.nearestAirport,
    };
    const formPayload = new FormData();

    let error = "";
    const fileInput = document.getElementById("photos");
    const file = fileInput?.files?.[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        error += "Photo image only allowed";
      } else {
        formPayload.append("photos", file);
      }
    }

    const fileInputresume = document.getElementById("resume");
    const fileresume = fileInputresume?.files?.[0];
    if (fileresume) {
      if (fileresume.type !== "application/pdf") {
        if (error !== "") {
          error += "<br/>";
        }
        error += "Resume PDF only allowed";
      } else {
        formPayload.append("resume", fileresume);
      }
    }
    if (error !== "") {
      showAlert("Error", error, "error");
      return false;
    }
    showLoader("submit_frm", "class");
    Object.keys(postObject).forEach((key) => {
      console.log(key, postObject[key], "postData[key]");
      formPayload.append(key, postObject[key]);
    });
    //formPayload.append("name", "John");

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(formPayload, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={this.state.editID !== "" ? `/candidate/view/${decodeValue(this.state.editID)}` : `/search`}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            rankList={this.state.rankList}
                            experienceList={this.state.experienceList}
                            countryList={this.state.countryList}
                            vessleTypeList={this.state.vessleTypeList}
                            companyList={this.state.companyList}
                            gradeList={this.state.gradeList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { fname, c_rank, nationality, dob, c_vessel, indos_number, c_mobi1, email1, email2, height, weight, active_details } = props.fields;

  return {
    fields: ["fname", "c_rank", "nationality", "dob", "c_vessel", "indos_number", "c_mobi1", "email1", "height", "weight", "active_details"],
    validations: {
      fname: [[isEmpty, fname]],
      c_rank: [[isSingleSelect, c_rank]],
      nationality: [[isSingleSelect, nationality]],
      dob: [[isEmpty, dob]],
      c_vessel: [[isSingleSelect, c_vessel]],
      indos_number: [[isEmpty, indos_number]],
      c_mobi1: [[isEmpty, c_mobi1]],
      email1: [
        [isEmail, email1],
        [isEmpty, email1],
      ],
      email2: [[isEmail, email2]],
      height: [[isNumberWithPoint, height]],
      weight: [[isNumberWithPoint, weight]],
      active_details: [[isSingleSelect, active_details]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoUrl: null,
      resumeType: "",
    };
    this.checkImages();
    this.fileInputRef = createRef();
  }

  checkImages() {
    const photos = this.props.fields.photos ? `${downloadUrl}views/public/files/photos/${this.props.fields.photos}` : null;
    if (photos !== "" && photos !== null) {
      fetch(`${downloadUrl}views/public/files/photos/${this.props.fields.photos}`, {
        method: "HEAD",
      })
        .then((res) => {
          if (res.ok) {
            this.setState({ photoUrl: `${downloadUrl}views/public/files/photos/${this.props.fields.photos}` });
          } else {
          }
        })
        .catch(() => {
          console.log("❌ Error — server unreachable or CORS blocked");
        });
    }
  }

  handleClick = () => {
    this.fileInputRef.current.click(); // Open file picker
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.setState({ photoUrl: previewUrl });
    }
  };

  goBack() {
    this.props.history.push(this.props.editID !== "" ? `/candidate/view/${decodeValue(this.state.editID)}` : `/search`);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handlecheckedChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }
  handleChangeMobile = (filed, value, country) => {
    console.log(filed, value, country, "countrycountrycountry");
    if (filed === "mobile1") {
      console.log(value.slice(country.dialCode.length));
      this.props.onChange("c_mobi1", value.slice(country.dialCode.length));
      setTimeout(() => {
        this.props.onChange("mobile_code1", "+" + country.dialCode);
      }, 100);
    } else if (filed === "mobile2") {
      this.props.onChange("c_mobi2", value.slice(country.dialCode.length));
      setTimeout(() => {
        this.props.onChange("mobile_code2", "+" + country.dialCode);
      }, 100);
    }
  };

  viewResume(e) {
    e.preventDefault();
    const slectedPDF_ = this.props.fields.resume ?? "";
    if (slectedPDF_ !== "") {
      const slectedPDFSplit_ = slectedPDF_.split(".");
      const resumeType = slectedPDFSplit_[slectedPDFSplit_.length - 1].toLowerCase();
      this.setState({ resumeType: resumeType }, () => {
        if (resumeType === "pdf") {
          $("#viewResume").trigger("click");
        } else {
          window.open(`${downloadUrl}views/public/files/resume/${this.props.fields.resume}`, "_blank");
        }
      });
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgfname,
      errMsgc_rank,
      errMsgnationality,
      errMsgdob,
      errMsgc_vessel,
      errMsgindos_number,
      errMsgc_mobi1,
      errMsgemail1,
      errMsgemail2,
      errMsgheight,
      errMsgweight,
      errMsgStatus = "";
    if ($validation.fname.error.reason !== undefined) {
      errMsgfname = $validation.fname.show && <span className="error">{$validation.fname.error.reason}</span>;
    }
    if ($validation.c_rank.error.reason !== undefined) {
      errMsgc_rank = $validation.c_rank.show && <span className="error">{$validation.c_rank.error.reason}</span>;
    }
    if ($validation.nationality.error.reason !== undefined) {
      errMsgnationality = $validation.nationality.show && <span className="error">{$validation.nationality.error.reason}</span>;
    }
    if ($validation.dob.error.reason !== undefined) {
      errMsgdob = $validation.dob.show && <span className="error">{$validation.dob.error.reason}</span>;
    }
    if ($validation.c_vessel.error.reason !== undefined) {
      errMsgc_vessel = $validation.c_vessel.show && <span className="error">{$validation.c_vessel.error.reason}</span>;
    }
    if ($validation.indos_number.error.reason !== undefined) {
      errMsgindos_number = $validation.indos_number.show && <span className="error">{$validation.indos_number.error.reason}</span>;
    }
    if ($validation.c_mobi1.error.reason !== undefined) {
      errMsgc_mobi1 = $validation.c_mobi1.show && <span className="error">{$validation.c_mobi1.error.reason}</span>;
    }
    if ($validation.email1.error.reason !== undefined) {
      errMsgemail1 = $validation.email1.show && <span className="error">{$validation.email1.error.reason}</span>;
    }
    if ($validation.email2?.error?.reason) {
      errMsgemail2 = $validation.email2.show && <span className="error">{$validation.email2.error.reason}</span>;
    }
    if ($validation.height.error.reason !== undefined) {
      errMsgheight = $validation.height.show && <span className="error">{$validation.height.error.reason}</span>;
    }
    if ($validation.weight.error.reason !== undefined) {
      errMsgweight = $validation.weight.show && <span className="error">{$validation.weight.error.reason}</span>;
    }
    if ($validation.active_details.error.reason !== undefined) {
      errMsgStatus = $validation.active_details.show && <span className="error">{$validation.active_details.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-10">
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="form-label">
                    First Name - Mid Name (As in Passport)<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="First Name - Mid Name (As in Passport)"
                    name="fname"
                    value={fields.fname}
                    {...$field("fname", (e) => onChange("fname", e.target.value))}
                  />
                  {errMsgfname}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Last Name</label>
                  <input type="text" className="form-control upper-case" placeholder="Last Name" name="lname" value={fields.lname} {...$field("lname", (e) => onChange("lname", e.target.value))} />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Rank Experience<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.c_rank} onChange={this.handleSelectChange.bind(this, "c_rank")} placeholder="Select Rank Experience" isClearable={true} options={this.props.rankList} />
                  {errMsgc_rank}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Availability</label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Availability"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.avb_date}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "avb_date")}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Nationality<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.nationality}
                    onChange={this.handleSelectChange.bind(this, "nationality")}
                    placeholder="Select Nationality"
                    isClearable={true}
                    options={this.props.countryList}
                  />
                  {errMsgnationality}
                </div>

                <div className="form-group col-md-3">
                  <label className="form-label">Marital Status</label>
                  <Select value={fields.m_status} onChange={this.handleSelectChange.bind(this, "m_status")} placeholder="Select Marital Status" isClearable={true} options={getMaritalStatus()} />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Date Of Birth<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Date Of Birth"
                    className="form-control"
                    maxDate={maxDate}
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.dob}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "dob")}
                  />
                  {errMsgdob}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Birth Place</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Birth Place"
                    name="birth_place"
                    value={fields.birth_place}
                    {...$field("birth_place", (e) => onChange("birth_place", e.target.value))}
                  />
                </div>
              </div>
            </div>
            <div className="form-group col-md-2">
              <div className="photo-container" onClick={this.handleClick}>
                <img src={this.state.photoUrl || noImage} alt="profile" className="photo" />
                <div className="photo-overlay">{this.state.photoUrl ? "Change Photo" : "Add Photo"}</div>
                <input type="file" hidden ref={this.fileInputRef} accept="image/*" id="photos" onChange={this.handleFileChange} />
              </div>
              {fields.candidateId !== "" && (
                <h4 className="text-center text-primary mt-1">
                  <b>Nemo ID : {fields.candidateId}</b>
                </h4>
              )}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">Worked with us</label>
              <Select
                value={fields.work_nautilus}
                onChange={this.handleSelectChange.bind(this, "work_nautilus")}
                placeholder="Select Worked with us"
                isClearable={true}
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Vessel Type<span className="lbl-error">*</span>
              </label>
              <Select value={fields.c_vessel} onChange={this.handleSelectChange.bind(this, "c_vessel")} placeholder="Select Vessel Type" isClearable={true} options={this.props.vessleTypeList} />
              {errMsgc_vessel}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                INDOS Number<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="INDOS Number"
                name="indos_number"
                value={fields.indos_number}
                {...$field("indos_number", (e) => onChange("indos_number", e.target.value))}
              />
              {errMsgindos_number}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Experience</label>
              <Select value={fields.experience} onChange={this.handleSelectChange.bind(this, "experience")} placeholder="Select Experience" isClearable={true} options={this.props.experienceList} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Mobile 1<span className="lbl-error">*</span>
              </label>
              <PhoneInput
                inputClass="form-control"
                country={"in"} // default country (india)
                value={`+${fields.mobile_code1} ${fields.c_mobi1}`}
                onChange={this.handleChangeMobile.bind(this, "mobile1")}
              />
              {errMsgc_mobi1}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Mobile 2</label>
              <PhoneInput
                inputClass="form-control"
                country={"in"} // default country (india)
                value={`+${fields.mobile_code2} ${fields.c_mobi2}`}
                onChange={this.handleChangeMobile.bind(this, "mobile2")}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Email 1<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Email 1" name="email1" value={fields.email1} {...$field("email1", (e) => onChange("email1", e.target.value))} />
              {errMsgemail1}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Email 2</label>
              <input type="text" className="form-control" placeholder="Email 2" name="email2" value={fields.email2} {...$field("email2", (e) => onChange("email2", e.target.value))} />
              {errMsgemail2}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">Zone</label>
              <Select
                value={fields.zone}
                onChange={this.handleSelectChange.bind(this, "zone")}
                placeholder="Select Zone"
                isClearable={true}
                options={[
                  { label: "East", value: "East" },
                  { label: "West", value: "West" },
                  { label: "North", value: "North" },
                  { label: "South", value: "South" },
                ]}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Grade</label>
              <Select value={fields.grade} onChange={this.handleSelectChange.bind(this, "grade")} placeholder="Select Grade" isClearable={true} options={this.props.gradeList} />
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">Boiler suit size</label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Boiler suit size"
                name="boiler_suit_size"
                value={fields.boiler_suit_size}
                {...$field("boiler_suit_size", (e) => onChange("boiler_suit_size", e.target.value))}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Safety Shoe Size</label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Safety Shoe Size"
                name="safety_shoe_size"
                value={fields.safety_shoe_size}
                {...$field("safety_shoe_size", (e) => onChange("safety_shoe_size", e.target.value))}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Height(cm)</label>
              <input type="text" className="form-control upper-case" placeholder="Height(cm)" name="height" value={fields.height} {...$field("height", (e) => onChange("height", e.target.value))} />
              {errMsgheight}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Weight (KGS)</label>
              <input type="text" className="form-control upper-case" placeholder="Weight (KGS)" name="weight" value={fields.weight} {...$field("weight", (e) => onChange("weight", e.target.value))} />
              {errMsgweight}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">License Country</label>
              <Select value={fields.l_country} onChange={this.handleSelectChange.bind(this, "l_country")} placeholder="Select License Country" isClearable={true} options={this.props.countryList} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Group</label>
              <Select
                value={fields.group}
                onChange={this.handleSelectChange.bind(this, "group")}
                placeholder="Select Group"
                isClearable={true}
                options={[
                  { label: "Officer", value: "1" },
                  { label: "Rating", value: "2" },
                  { label: "IV crew", value: "6" },
                ]}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Client</label>
              <Select value={fields.vendor} onChange={this.handleSelectChange.bind(this, "vendor")} placeholder="Select Client" isClearable={true} options={this.props.companyList} />
            </div>
            <div className="form-group col-md-3">
              <div class="form-group">
                <label class="form-label">Resume</label>
                <div className="input-group">
                  <input class="form-control" type="file" id="resume" accept="application/pdf" />
                  {fields.resume !== "" && (
                    <a href="/" onClick={this.viewResume.bind(this)}>
                      <span className="input-group-text btn btn-secondary shadow-none" title="View Resume" style={{ margin: 0, height: "100%" }}>
                        <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                      </span>
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">US Visa</label>
              <Select
                value={fields.us_visa}
                onChange={this.handleSelectChange.bind(this, "us_visa")}
                placeholder="Select US Visa"
                isClearable={true}
                options={[
                  { label: "Yes", value: "1" },
                  { label: "No", value: "0" },
                ]}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.active_details}
                onChange={this.handleSelectChange.bind(this, "active_details")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: 1, label: "Active" },
                  { value: 0, label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Nearest Airport</label>
              <input type="text" className="form-control upper-case" placeholder="Nearest Airport" name="nearestAirport" value={fields.nearestAirport} {...$field("nearestAirport", (e) => onChange("nearestAirport", e.target.value))} />
            </div>
            
            <div className="form-group col-md-12">
              <div class="card-alert alert alert-primary mb-0">
                <b style={{ fontSize: "19px" }}>Primary Address</b>
              </div>
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Address<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="Address" name="c_ad1" value={fields.c_ad1} {...$field("c_ad1", (e) => onChange("c_ad1", e.target.value))} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Country</label>
              <Select value={fields.c_country} onChange={this.handleSelectChange.bind(this, "c_country")} placeholder="Select Country" isClearable={true} options={this.props.countryList} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">City</label>
              <input type="text" className="form-control upper-case" placeholder="City" name="c_city" value={fields.c_city} {...$field("c_city", (e) => onChange("c_city", e.target.value))} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">State</label>
              {(fields.c_country?.value ?? "").toString() === "108" ? (
                <Select value={fields.c_state} onChange={this.handleSelectChange.bind(this, "c_state")} placeholder="Select State" isClearable={true} options={getStateList()} />
              ) : (
                <input type="text" className="form-control upper-case" placeholder="State" name="c_state" value={fields.c_state} {...$field("c_state", (e) => onChange("c_state", e.target.value))} />
              )}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Pin Code</label>
              <input type="text" className="form-control upper-case" placeholder="Pin Code" name="c_pin" value={fields.c_pin} {...$field("c_pin", (e) => onChange("c_pin", e.target.value))} />
            </div>

            <div className="form-group col-md-12">
              <div class="card-alert alert alert-primary mb-0">
                <b style={{ fontSize: "19px" }}>Alternate Address</b>
              </div>
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Address<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="Address" name="p_ad1" value={fields.p_ad1} {...$field("p_ad1", (e) => onChange("p_ad1", e.target.value))} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Country</label>
              <Select value={fields.p_country} onChange={this.handleSelectChange.bind(this, "p_country")} placeholder="Select Country" isClearable={true} options={this.props.countryList} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                City<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="City" name="p_city" value={fields.p_city} {...$field("p_city", (e) => onChange("p_city", e.target.value))} />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">State</label>
              {(fields.p_country?.value ?? "").toString() === "108" ? (
                <Select value={fields.p_state} onChange={this.handleSelectChange.bind(this, "p_state")} placeholder="Select State" isClearable={true} options={getStateList()} />
              ) : (
                <input type="text" className="form-control upper-case" placeholder="State" name="p_state" value={fields.p_state} {...$field("p_state", (e) => onChange("p_state", e.target.value))} />
              )}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Pin Code</label>
              <input type="text" className="form-control upper-case" placeholder="Pin Code" name="p_pin" value={fields.p_pin} {...$field("p_pin", (e) => onChange("p_pin", e.target.value))} />
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
        <button class="btn btn-secondary bg-secondary-gradient mt-3" data-bs-toggle="modal" data-bs-target="#extralargemodal" id="viewResume" style={{ display: "none" }}>
          Extralarge Modal
        </button>
        <div class="modal fade" id="extralargemodal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Resume Details</h5>
                <button class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.resumeType === "pdf" && (
                <div class="modal-body">{fields.resume !== "" && <iframe src={`${downloadUrl}views/public/files/resume/${fields.resume}`} width="100%" height="500px" title="View File"></iframe>}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
